module.exports = __webpack_public_path__ + "img/Button diameter.636edb0f.png";